import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SortOptionsByPageState, sortOptionsByPageFeatureKey } from "./sort-by.reducer";

export const selectSortOptionsByPageState = createFeatureSelector<SortOptionsByPageState>(sortOptionsByPageFeatureKey);

export const selectSortByRLP = createSelector(selectSortOptionsByPageState, (state: SortOptionsByPageState) => state.sortByRLP);
export const selectOrderByRLP = createSelector(selectSortOptionsByPageState, (state: SortOptionsByPageState) => state.orderByRLP);
export const selectSortByTLP = createSelector(selectSortOptionsByPageState, (state: SortOptionsByPageState) => state.sortByTLP);
export const selectOrderByTLP = createSelector(selectSortOptionsByPageState, (state: SortOptionsByPageState) => state.orderByTLP);